import React from 'react';
// import PropTypes from 'prop-types';
import styles from './SearchDropdownSorting.module.scss';
import SearchDropdown from '../SearchDropdown';
import { useTranslation } from 'next-i18next';
import { useContextState } from '../StateProvider';

const SearchDropdownSorting = () => {
    const { t } = useTranslation('common');
    const [{ sorting, sortChoices = [] } = {}, dispatch] = useContextState();
    const activeSorting = [sorting];

    return (
        <div className={styles['SearchDropdownSorting']}>
            <SearchDropdown
                items={sortChoices}
                activeItems={activeSorting}
                getActiveItemTitle={(obj) => {
                    return sortChoices.filter((i) => i.path === obj)[0]?.title;
                }}
                onItemClick={(item) => {
                    dispatch({ type: 'set_sorting', payload: item.path });
                    dispatch({ type: 'set_current_page', payload: 1 });
                    dispatch({ type: 'set_searching', payload: true });
                }}
                dropdownLabel={t('search.sortingDropdownLabel')}
                hideDropdownLabel={true}
            />
        </div>
    );
};

SearchDropdownSorting.propTypes = {};

export default SearchDropdownSorting;
